import $ from 'jquery';
import EventEmitter from '../event-emitter';
import inherit from '../inherit';
import iframeTemplate from './iframe.hbs';
import { DESTROY, LOAD, READY, ERROR } from "./events";

const $template = $.templates(iframeTemplate);

function KakaoTVPlayer(configs) {
  EventEmitter.call(this);
  this.configs       = configs;
  this.$playerIframe = null;
}

$.extend(KakaoTVPlayer, {
  host() {
    return 'https://kakaotv.daum.net';
  },
  boolToBin(bool) {
    return bool ? 1 : 0;
  },
  makeParams({ autoplay, service, profile, wmode }) {
    return $.param({
      autoplay: KakaoTVPlayer.boolToBin(autoplay),
      service,
      profile,
      wmode
    });
  },
  makeSourceURL(videoId, { autoplay, service, profile, wmode }) {
    const host   = KakaoTVPlayer.host();
    const params = KakaoTVPlayer.makeParams({ autoplay, service, profile, wmode });
    return `${host}/embed/player/cliplink/${videoId}@my?${params}`;
  }
});

inherit(KakaoTVPlayer, EventEmitter, {
  createIframe({ videoId, title }) {
    this.$playerIframe = $($template.render({
      src   : KakaoTVPlayer.makeSourceURL(videoId, this.configs),
      title : $.string.stripTags(title),
      width : this.configs.width,
      height: this.configs.height,
      style : $.map(this.configs.style, (val, key) => `${key}:${val}`).join(';')
    }));
    this.emit(LOAD);
    this.$playerIframe.one('load', (e) => {
      this.emit(READY, e);
    });
    this.$playerIframe.one('error', (e) => {
      this.emit(ERROR, e);
    });

    return this.$playerIframe;
  },
  load($container, { videoId, title }) {
    if (this.$playerIframe) {
      this.destroy();
    }
    const $player = this.createIframe({ videoId, title });
    $container.html($player);
  },
  destroy() {
    if (this.$playerIframe) {
      this.$playerIframe.remove();
      this.$playerIframe = null;
      this.emit(DESTROY);
    }
  }
});

export default KakaoTVPlayer;



/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/kakaotv-url-player/kakaotv-player.js
 **/